import type {ComponentPropsWithoutRef} from 'react';

export type FieldMessageTone='hint'|'error';
export type FieldMessageProps=ComponentPropsWithoutRef<'span'>&{
  tone?:FieldMessageTone;
  focusable?:boolean;
};

export function FieldMessage({tone='hint',focusable=false,className,role,tabIndex,...props}:FieldMessageProps){
  return <span
    {...props}
    className={['field-message',`field-message--${tone}`,className].filter(Boolean).join(' ')}
    role={role}
    tabIndex={tabIndex??(focusable?-1:undefined)}
  />;
}
